const HTTP = Object.freeze({
  get: 'GET',
  head: 'HEAD',
  post: 'POST',
  put: 'PUT',
  del: 'DELETE',
  opt: 'OPTIONS',
  patch: 'PATCH',
});

// noinspection JSUnusedGlobalSymbols
export default HTTP;
